// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"30234410","603":"68d616f3","794":"2177d4d8","925":"aecf1b56","955":"f8ba4ba1"}[chunkId] + ".chunk.js";
};